import { StockTypeStatus } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class RackZoneLevelRequest{
    @ApiProperty()
    zoneId?:number;
    @ApiProperty()
    rackId?:number;
    @ApiProperty()
    levelId?:number;
    @ApiProperty()
    stockType?:StockTypeStatus;
    @ApiProperty()
    unitId:any;
    @ApiProperty()
    reportingFromDate:any
    @ApiProperty()
    reportingToDate:any
    @ApiProperty()
    role:string
    @ApiProperty()
    variantCode?: any;
    @ApiProperty()
    loginUnit?: number;
}
